// src/App.jsx
import { Toaster } from "@/components/ui/toaster"
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClientInstance } from '@/lib/query-client'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Ajustado a los alias definidos en tu vite.config.js
import PageNotFound from '@lib/PageNotFound';
import ScrollToTop from '@components/ScrollToTop';

// Páginas importadas usando el alias @pages
import Home from '@pages/Home';
import AvisoPrivacidad from '@pages/AvisoPrivacidad';
import TerminosCondiciones from '@pages/TerminosCondiciones';

// WhatsApp Button
import WhatsAppButton from "@/components/ui/WhatsAppButton";

function App() {
  return (
    <QueryClientProvider client={queryClientInstance}>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aviso-privacidad" element={<AvisoPrivacidad />} />
          <Route path="/terminos-condiciones" element={<TerminosCondiciones />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
        <WhatsAppButton />
        <Toaster />
      </Router>
    </QueryClientProvider>
  )
}

export default App